import { FieldInputType } from 'constants/fields';
import { LoanChangesHistoryEntityType } from 'constants/loanChanges';

export const excludedOnUiFieldsConfig = {
  [LoanChangesHistoryEntityType.LOAN]: {
    loanOfficerId: {
      nameInModel: 'loanOfficerId',
      inputProps: { label: 'LO Name' },
    },
    programId: {
      nameInModel: 'programId',
      inputProps: { label: 'Program' },
    },
    rateSheetId: {
      nameInModel: 'rateSheetId',
      inputProps: { label: 'Rate Sheet' },
    },
    dti: {
      nameInModel: 'dti',
      inputProps: { label: 'Debt To Income', type: FieldInputType.TEXT },
    },
    tip: {
      nameInModel: 'tip',
      inputProps: { label: 'Total Interest Percentage' },
    },
    prepaids: {
      nameInModel: 'prepaids',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    netRentalIncome: {
      nameInModel: 'netRentalIncome',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    pmi: {
      nameInModel: 'pmi',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    feesAmount: {
      nameInModel: 'feesAmount',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    fiveYearTotals: {
      nameInModel: 'fiveYearTotals',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    prepaidInterest: {
      nameInModel: 'prepaidInterest',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    principalAndInterestInFiveYears: {
      nameInModel: 'principalAndInterestInFiveYears',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    principalInFiveYears: {
      nameInModel: 'principalInFiveYears',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    estimatedEscrow: {
      nameInModel: 'estimatedEscrow',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    originationCharges: {
      nameInModel: 'originationCharges',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    servicesYouCannotShopFor: {
      nameInModel: 'servicesYouCannotShopFor',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    servicesYouCanShopFor: {
      nameInModel: 'servicesYouCanShopFor',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    totalLoanCosts: {
      nameInModel: 'totalLoanCosts',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    taxesAndOtherGovernmentFees: {
      nameInModel: 'taxesAndOtherGovernmentFees',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    initialEscrowPaymentAtClosing: {
      nameInModel: 'initialEscrowPaymentAtClosing',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    otherCosts: {
      nameInModel: 'otherCosts',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    totalOtherCosts: {
      nameInModel: 'totalOtherCosts',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    totalClosingCosts: {
      nameInModel: 'totalClosingCosts',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    estimatedCashToClose: {
      nameInModel: 'estimatedCashToClose',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    totalLoanAndOtherCosts: {
      nameInModel: 'totalLoanAndOtherCosts',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    fundsFromBorrower: {
      nameInModel: 'fundsFromBorrower',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    deposit: {
      nameInModel: 'deposit',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    fundsForBorrower: {
      nameInModel: 'fundsForBorrower',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    closingCostsFinanced: {
      nameInModel: 'closingCostsFinanced',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    otherCredit: {
      nameInModel: 'otherCredit',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    liabilitiesAmount: {
      nameInModel: 'liabilitiesAmount',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    totalPayoffsAndPayments: {
      nameInModel: 'totalPayoffsAndPayments',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    prepaidsHomeownersInsurance: {
      nameInModel: 'prepaidsHomeownersInsurance',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    prepaidsMortgageInsurance: {
      nameInModel: 'prepaidsMortgageInsurance',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    prepaidsPropertyTaxes: {
      nameInModel: 'prepaidsPropertyTaxes',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    escrowedHomeownersInsurance: {
      nameInModel: 'escrowedHomeownersInsurance',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    escrowedMortgageInsurance: {
      nameInModel: 'escrowedMortgageInsurance',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    escrowedPropertyTaxes: {
      nameInModel: 'escrowedPropertyTaxes',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    programDiscountAmount: {
      nameInModel: 'programDiscountAmount',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    interestOnlyPayment: {
      nameInModel: 'interestOnlyPayment',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    hcLoanAmount: {
      nameInModel: 'hcLoanAmount',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    cLoanAmount: {
      nameInModel: 'cLoanAmount',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    housingExpenseRatio: {
      nameInModel: 'housingExpenseRatio',
      inputProps: { type: FieldInputType.TEXT },
    },
    programOriginationFeeRate: {
      nameInModel: 'programOriginationFeeRate',
      inputProps: { type: FieldInputType.CURRENCY },
    },
  },
  [LoanChangesHistoryEntityType.APPLICATION]: {
    downPaymentValue: {
      nameInModel: 'downPaymentValue',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    firstMortgageBalance: {
      nameInModel: 'firstMortgageBalance',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    secondMortgageBalance: {
      nameInModel: 'secondMortgageBalance',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    firstPartCost5Year: {
      nameInModel: 'firstPartCost5Year',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    firstPartFees: {
      nameInModel: 'firstPartFees',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    firstPartPaymentMonth: {
      nameInModel: 'firstPartPaymentMonth',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    firstPartPmi: {
      nameInModel: 'firstPartPmi',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    secondPartCost5Year: {
      nameInModel: 'secondPartCost5Year',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    secondPartFees: {
      nameInModel: 'secondPartFees',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    secondPartPaymentMonth: {
      nameInModel: 'secondPartPaymentMonth',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    secondPartPmi: {
      nameInModel: 'secondPartPmi',
      inputProps: { type: FieldInputType.CURRENCY },
    },
  },
  [LoanChangesHistoryEntityType.INCOME]: {
    grossMonthlyOtherIncome: {
      nameInModel: 'grossMonthlyOtherIncome',
      inputProps: { type: FieldInputType.CURRENCY },
    },
  },
  [LoanChangesHistoryEntityType.LIABILITY]: {
    creditLimitAmount: {
      nameInModel: 'creditLimitAmount',
      inputProps: { type: FieldInputType.CURRENCY },
    },
  },
  [LoanChangesHistoryEntityType.PROPERTY]: {
    annualHomeownersInsurance: {
      nameInModel: 'annualHomeownersInsurance',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    annualPropertyTaxes: {
      nameInModel: 'annualPropertyTaxes',
      inputProps: { type: FieldInputType.CURRENCY },
    },
  },
  [LoanChangesHistoryEntityType.LOAN_FEE_HISTORY]: {
    newAmount: {
      nameInModel: 'newAmount',
      inputProps: { type: FieldInputType.CURRENCY },
    },
    oldAmount: {
      nameInModel: 'oldAmount',
      inputProps: { type: FieldInputType.CURRENCY },
    },
  },
  [LoanChangesHistoryEntityType.LOAN_FUNDING]: {
    warehouseBankId: {
      nameInModel: 'warehouseBankId',
      inputProps: { label: 'Warehouse Bank' },
    },
  },
  [LoanChangesHistoryEntityType.LOAN_CLOSING_INVESTOR]: {
    warehouseBankId: {
      nameInModel: 'investorId',
      inputProps: { label: 'Investor' },
    },
  },
};
